<template>
  <div>
    <div class="search-con search-con-top">
      <Input clearable placeholder="请输入员工姓名" class="search-input" v-model="param.name"/>
      <Input clearable placeholder="请输入手机号" class="search-input" v-model="param.phone"/>
      <Button @click="searchInfo()" class="search-btn" v-if="this.$getMenuAuthority('sys:saleman:list')" type="primary"><Icon type="search"/>搜索</Button>
      <Button @click="iniSearch()">重置</Button>
      <Button @click="editInfo(false)" v-if="this.$getMenuAuthority('sys:saleman:save')" type="primary"><Icon type="search"/>新增</Button>
    </div>
    <Modal v-model="editModalShow" @on-ok="saveInfo()" scrollable title="编辑">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="80" class="edit-win">
        <FormItem label="员工姓名" prop="name">
          <Input v-model="formValidate.name" placeholder="请输入模板名" style="width: 380px"></Input>
        </FormItem>
        <FormItem label="员工电话" prop="path">
          <Input v-model="formValidate.phone" placeholder="请输入员工电话" style="width: 380px"></Input>
        </FormItem>
        <FormItem label="车行分组" prop="plimit">
          <Select v-model="formValidate.groupid" style="width:380px;">
            <Option v-for="item in carServeList" :key="item.id" :value="item.id">{{item.name}}</Option>
          </Select>
        </FormItem>
      </Form>
    </Modal>
    <Table border :columns="columns1" :data="showData.list"></Table>
    <div class="page-con">
      <Page show-total :total="showData.total" :page-size="10" @on-change="chagepage" :current="showData.pageNum" show-elevator class="pull-right" />
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      editModalShow: false,  //弹出框提示
      carServeList:[],
      param: {              //查询条件
        pageNum: 1,
        name:'',
        phone:'',
      },
      showData: {           //列表容器,
        pageNum: 1
      },
      formValidate: {
        name: '',
        phone: '',
        groupid: '',
      },
      ruleValidate: {
        name: [
          { required: true, message: '员工姓名名不能为空', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '电话不能为空', trigger: 'blur' }
        ],
        groupid: [
          { required: true, message: '车行不能为空', trigger: 'blur' }
        ],
      },
      columns1: [           //表头
        {title: '编号',key: 'id'},
        {title: '员工姓名',key: 'name'},
        {title: '电话',key: 'phone'},
        {title: '所在车行',key: 'phone'},
        {title: '操作',key: 'action',width: 150,align: 'center',
          render: (h, params) => {
            return h('div', [
              h('Button', {
                props: {type: 'primary',size: 'small'},
                style: {marginRight: '5px',display: this.$getMenuAuthority('sys:saleman:update') ? 'inline-block' : 'none'},
                on: {
                  click: () => {
                    this.editInfo(params.row)
                  }
                }
              }, '编辑'),
              h('Button', {
                props: {type: 'error',size: 'small'},
                style: {marginRight: '5px',display: this.$getMenuAuthority('sys:saleman:delete') ? 'inline-block' : 'none'},
                on: {
                  click: () => {
                    this.deleteInfo(params.row.id)
                  }
                }
              }, '删除')
            ])
          }
        }
      ]
    }
  },
  activated() {
    this.getList ()
    this.getCarServeList()
  },
  mounted () {
    this.getList ()
    this.getCarServeList()
  },
  methods: {
    searchInfo() {
      this.showData.pageNum = 1
      this.getList()
    },
    chagepage (current) {
      this.param.pageNum = current
      this.getList()
    },
    getCarServeList () {   //获取车行列表
      this.$Loading.start()
      this.$axios.get('/policy/group')
      .then(function (response) {
        if (response.data.success) {
          this.carServeList = response.data.data
          this.$Loading.finish()
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    iniSearch() {
      this.showData.name = ''
      this.showData.phone = ''
    },
    getList () {   //获取列表
      this.$Loading.start()
      this.$axios.get('/saleman/list/'+this.param.pageNum+'?name='+this.param.name+'&phone='+this.param.phone)
      .then(function (response) {
        if (response.data.success) {
          this.showData = response.data.data
          this.$Loading.finish()
        } else {
          this.$Message.error(response.data.errMsg)
          this.$Loading.error()
        }
      }.bind(this))
    },
    editInfo (param) {
      if(param) {
        this.formValidate = param
      } else {
        this.formValidate = {name: '',
        phone: '',
        groupid: '',
        }
      }
      this.editModalShow = true
    },
    deleteInfo(id) {
      this.$Modal.confirm({
        title: '删除',
        content: '<p>您确定要删除吗</p>',
        onOk: () => {
            this.$Loading.start()
            this.$axios.get('/saleman/delete/'+id)
            .then(function (response) {
                if (response.data.success) {
                  this.getList()
                  this.$Message.success(response.data.errMsg)
                  this.$Loading.finish()
                } else {
                  this.$Message.error(response.data.errMsg)
                  this.$Loading.error()
                }
            }.bind(this))
        },
        onCancel: () => {
          this.$Message.warning('已取消删除')
        }
      });
    },
    saveInfo () {
      this.$refs.formValidate.validate((valid) => {
        if (valid) {
          this.$Loading.start()
          let url = ''
          if(this.formValidate.id) {
            url = '/saleman/update'
          } else {
            url = '/saleman/save'
          }
          this.$axios.post(url,this.formValidate)
          .then(function (response) {
            if (response.data.success) {
              this.getList ()
              this.$Loading.finish()
            } else {
              this.$Message.error(response.data.errMsg)
              this.$Loading.error()
            }
          }.bind(this))
        }
      })
    }
  }
}
</script>




// WEBPACK FOOTER //
// src/views/saleman/list.vue